<!--
 * @Author: junfeng.liu
 * @Date: 2018-12-11 14:40:45
 * @LastEditors: junfeng.liu
 * @LastEditTime: 2019-05-31 10:01:47
 * @Description: 文件上传组件
    props:
        value：         绑定的值(支持v-model)
        single：        是否只支持单文件上传
        headers：       请求头
        name：          上传的文件字段名
        data：          上传的附带额外参数
        action：        上传地址
        accept：        限制文件类型
        maxSize：       限制文件大小
        multiple：      是否可以多选
        disabled：      是否禁用
        type：          设置value的格式
    
    emit：
        success：       文件上传成功时触发
        on-change：     文件变动时触发
 -->

<template>
    <div class="bp-file-upload">
        <div class="upload-file-list">
            <div class="upload-file-item" v-for="(item,index) in fileListCom" :key="item.fileName">
                <div class="img-box" :class="{'onlyImg': !showFileName}" @click="imgClick(item.path)" v-if="accept.indexOf('image') !== -1"><img :src="item.path" /></div>
                <i class="iconfont icon-wenjian" v-else></i>
                <div class="upload-file-name" v-if="showFileName">{{item.fileName}}</div>
                <div class="upload-del-btn" @click="delFile(index)" v-if="!disabled">
					<Icon type="md-close-circle" />
				</div>
            </div>
            <Upload
                v-if="showUpload && !disabled"
                :headers="headers"
                :name="name"
                :data="data"
                :action="action"
                :accept="accept"
                :maxSize="maxSize"
                :multiple="multiple"
                :showUploadList="showUploadList"
                :on-success="handleSuccess"
                :on-error="handleError"
                :on-progress="handleProgress"
                :on-exceeded-size="handleExcSize"
                :on-format-error="handleFormatErr"
                >
                <div class="upload-btn">
                    <i class="iconfont icon-shangchuan"></i>
                    <div class="upload-btn-text">点击上传</div>
                    <div class="upload-progress" :style="{width: progressWidth}"></div>
                </div>
            </Upload>
            <div class="upload-btn" v-else-if="showUpload && disabled">
                <i class="iconfont icon-shangchuan"></i>
                <div class="upload-btn-text">点击上传</div>
            </div>
        </div>
    </div>
</template>

<script>
import {check} from '@/utils'
import {mapGetters} from 'vuex'

export default {
    props: {
        value: {
            type: [String, Array]
        },
        single: {
            type: Boolean,
            default: true
        },
        type: {
            type: Object,
            default: () => {
                return {
                    type: 'array', // 'array','nameAndPath','name','path','nameArray','pathArray'
                    nameKey: 'fileName',
                    pathKey: 'path'
                    // nameSeparator: ':',
                    // fileSeparator: '|'
                }
            }
        },
        header: {
            type: Object,
            default: () => {
                return {}
            }
        },
        name: {
            type: [String, Number],
            default: 'file'
        },
        data: {
            type: Object,
            default: () => {
                return {}
            }
        },
        action: {
            type: String,
            default: '/web/file/upload'
        },
        accept: {
            type: String, // image/jpeg,image/bmp,image/gif,image/png
            default: 'application/x-x509-ca-cert'
        },
        maxSize: {
            type: Number,
            default: 1024
        },
        multiple: {
            type: Boolean,
            default: false
        },
        showUploadList: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        showUploadBtn: {
            type: Boolean,
            default: true
        },
        showFileName: {
            type: Boolean,
            default: true
        },
        APIUrl: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            fileList: [],
            headers: {},
            progressWidth: 0
        }
    },
    watch: {
        value (val) {
            this.filterValue(val)
        }
    },
    computed: {
        ...mapGetters(['token']),
        showUpload () {
            if (!this.showUploadBtn) return false
            if (this.single && this.fileList.length >= 1) {
                return false
            }
            return true
        },
        fileListCom () { // 调整文件列表
            if (this.accept.indexOf('image') === -1 || !this.fileList) return this.fileList
            let list = []
            for (let item of this.fileList) {
                if (item.path.includes('showImage')) {
                    list.push(item)
                    continue
                }
                let obj = Object.assign({}, item)
                obj.path = this.APIUrl || '' + obj.path
                list.push(obj)
            }
            return list
        }
    },
    mounted () {
        this.setTokenToHeaders()
    },
    methods: {
        setTokenToHeaders () {
            if (check.isEmptyObject(this.header)) {
                this.headers = {token: this.token}
            }
        },
        imgClick (src) {
            window.open(src)
        },
        filterValue (val) {
            if (check.isNull(val)) return
            let nameKey = this.type.nameKey
            let pathKey = this.type.pathKey
            let nameSeparator = this.type.nameSeparator ? this.type.nameSeparator : ':'
            let fileSeparator = this.type.fileSeparator ? this.type.fileSeparator : '|'
            let arr = []
            this.fileList = []
            switch (this.type.type) {
                case 'array':
                    if (!Array.isArray(val)) return
                    for (let item of val) {
                        let obj = {fileName: item[nameKey], path: item[pathKey]}
                        this.fileList.push(obj)
                    }
                    break
                case 'pathArray':
                case 'nameArray':
                    if (!Array.isArray(val)) return
                    for (let item of val) {
                        let obj = {fileName: item, path: item}
                        this.fileList.push(obj)
                    }
                    break
                case 'path':
                case 'name':
                    if (typeof val !== 'string') return
                    if (check.isNull(fileSeparator)) {
                        this.fileList.push({fileName: val, path: val})
                        return
                    }
                    arr = val.split(fileSeparator)
                    for (let item of arr) {
                        let obj = {fileName: item, path: item}
                        this.fileList.push(obj)
                    }
                    break
                case 'nameAndPath':
                    if (typeof val !== 'string') return
                    if (check.isNull(fileSeparator)) {
                        let a = val.split(nameSeparator)
                        this.fileList.push({fileName: a[0], path: a[1] ? a[1] : a[0]})
                        return
                    }
                    arr = val.split(fileSeparator)
                    for (let item of arr) {
                        let a = item.split(nameSeparator)
                        this.fileList.push({fileName: a[0], path: a[1] ? a[1] : a[0]})
                    }
                    break
            }
        },
        filterResult () {
            let nameKey = this.type.nameKey
            let pathKey = this.type.pathKey
            let nameSeparator = this.type.nameSeparator ? this.type.nameSeparator : ':'
            let fileSeparator = this.type.fileSeparator ? this.type.fileSeparator : '|'
            let type = this.type.type
            let arr = []
            let result = type.indexOf('rray') !== -1 ? [] : ''
            for (let item of this.fileList) {
                switch (type) {
                    case 'array':
                        let obj = {}
                        obj[nameKey] = item.fileName
                        obj[pathKey] = item.path
                        result.push(obj)
                        break
                    case 'pathArray':
                        result.push(item.path)
                        break
                    case 'nameArray':
                        result.push(item.fileName)
                        break
                    case 'path':
                        result += item.path + fileSeparator
                        break
                    case 'name':
                        result += item.fileName + fileSeparator
                        break
                    case 'nameAndPath':
                        result += item.fileName + nameSeparator + item.path + fileSeparator
                        break
                }
            }
            return type.indexOf('rray') !== -1 ? result : result.substring(0, result.length - fileSeparator.length)
        },
        handleSuccess (res) { // 设定返回格式为{fileName：name,path: path}
            this.progressWidth = 0
            if (res.code !== '00000') {
                return this.$Message.error(res.message)
            }
            if (this.single) {
                this.fileList = []
            }
            this.fileList.push(res.data)
            let result = this.filterResult()
            this.$emit('input', result)
            this.$emit('success', result)
            this.$emit('on-change', result)
        },
        handleError (err) {
            this.$Message.error(`出错啦!${err}`)
            this.$emit('error', err)
        },
        handleProgress (e, file, fileList) {
            this.progressWidth = e.percent + '%'
        },
        handleExcSize (file, fileList) {
            this.$Message.error(`文件大小不得超过${this.maxSize}Kb`)
        },
        handleFormatErr (file, fileList) {
            this.$Message.error('请上传指定格式文件')
        },
        delFile (i) {
            this.fileList.splice(i, 1)
            let result = this.filterResult()
            this.$emit('input', result)
            this.$emit('on-change', result)
        }
    }
}
</script>

<style lang="less">
.bp-file-upload{
    line-height: normal;
    .ivu-upload{
        display: inline-block;
        vertical-align: top;
    }
    .upload-btn, .upload-file-item{
        width: 90px;
        height: 90px;
        text-align: center;
        border-radius: 3px;
        display: inline-block;
        color: #ccc;
        background: #ebecef;
        margin-right: 10px;
        margin-bottom: 10px;
        position: relative;
        .upload-progress{
            width: 100%;
            height: 5px;
            background: #19be6b;
            position: absolute;
            bottom: 0;
        }
        .iconfont{
            font-size: 40px;
            margin-top: 8px;
            display: inline-block;
        }
        .img-box{
            width: 90px;
            height: 60px;
            overflow: hidden;
            border: 1px solid #ccc;
            display: flex;
            align-items: center;
            justify-content: center;
            &.onlyImg{
                width: 90px;
                height: 90px;;
            }
            img{
                max-width: 100%;
                max-height: 100%;
                // transform: translateY(-25%);
            }
        }
        .upload-btn-text, .upload-file-name{
            line-height: 32px;
            font-size: 13px;
            color: #999;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            padding: 0px 5px;
        }
    }
    .upload-file-list{
        position: relative;
        .upload-file-item{
            position: relative;
            vertical-align: top;
            .upload-del-btn{
				position: absolute;
				top: -6px;
				right: -6px;
				font-size: 22px;
				background: white;
				border-radius: 50%;
				line-height: 1;
				color: black;
            }
        }
    }
}

</style>
